import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "form-items cf" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { class: "control" }
const _hoisted_6 = {
  class: "label",
  for: "Email"
}
const _hoisted_7 = { class: "fieldset" }
const _hoisted_8 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_9 = {
  class: "form-items",
  "data-type": "buttons"
}
const _hoisted_10 = { class: "item calltoaction" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "lable" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = ["innerHTML"]

import { ref } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountPasswordRemind',
  props: {
    recaptchaSiteKey: {}
  },
  setup(__props: any) {

const props = __props;

const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({});
const validationErrors = ref<any[]>([]);

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];

    isLoading.value = true;

    (window as any).grecaptcha.enterprise.ready(async () => {
        const token = await (window as any).grecaptcha.enterprise.execute(props.recaptchaSiteKey, { action: 'Submit' });
        try {
            let response = await Axios.post(routes.Account_PasswordRemind, formData.value, { headers: { "RecaptchaVerificationToken": token } });

            isSuccess.value = true;

            GTagHelper.sendEvent("form_submit", "account_login");

            window.location.href = response.data.redirectUrl ? response.data.redirectUrl : "/";
        } catch (error: any) {
            if (error.response && error.response.status === 400) {
                validationErrors.value = FormHelper.getValidationErrors(error.response.data);
            }
        }

        isLoading.value = false;
    });
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("fieldset", {
      class: "fieldset mrg",
      "data-mrgt": "20",
      disabled: isLoading.value
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(localizer).get("App.Account.Email")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              id: "Email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.email) = $event)),
              autocomplete: "email",
              class: _normalizeClass([{ 'input-validation-error': isValidationError('Email') }, 'textbox short'])
            }, null, 2), [
              [
                _vModelText,
                formData.value.email,
                void 0,
                { lazy: true }
              ]
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
          ])
        ])
      ])
    ], 8, _hoisted_2),
    _createElementVNode("fieldset", _hoisted_7, [
      (validationErrors.value.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            id: "ButtonSubmit",
            class: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (submitForm())),
            disabled: isLoading.value
          }, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(localizer).get("Account.Common.Button_Next")), 1)
          ], 8, _hoisted_11)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: "captcha-terms",
          innerHTML: _unref(localizer).get('App.Recaptcha.CaptchaTerms')
        }, null, 8, _hoisted_14)
      ])
    ])
  ]))
}
}

})